let player = null;
let apiReady = false;
let currentVideoId = null;
let closeTimeout = null;

const dialog = document.getElementById('dialog-video-player');
const closeButton = document.getElementById('close-video-player');

// Load the YouTube IFrame API once
const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
document.head.appendChild(tag);

// Called automatically by the API
window.onYouTubeIframeAPIReady = function () {
    apiReady = true;
};

function playVideo(videoId) {
    if (!apiReady) return;

    // Cancel any pending auto-close
    clearTimeout(closeTimeout);

    if (!player) {
        player = new YT.Player('youtube-player', {
            videoId,
            playerVars: {
                autoplay: 1,
                rel: 0,
                modestbranding: 1
            },
            events: {
                onReady(event) {
                    event.target.playVideo();
                },
                onStateChange(event) {

                    // Video finished
                    if (event.data === YT.PlayerState.ENDED) {
                        closeTimeout = setTimeout(() => {
                            if (dialog.open) {
                                dialog.close();
                            }
                        }, 2000);
                    }
                }
            }
        });

        currentVideoId = videoId;
    }

    else if (currentVideoId !== videoId) {
        player.loadVideoById(videoId);
        currentVideoId = videoId;
    }

    else {
        player.seekTo(0, true);
        player.playVideo();
    }

    if (!dialog.open) {
        dialog.showModal();
    }
}

// Event delegation for video triggers
document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-video-id]');
    if (!trigger) return;

    event.preventDefault();

    playVideo(trigger.dataset.videoId);
});

// Close button
closeButton.addEventListener('click', () => {
    dialog.close();
});

// Stop video whenever dialog closes
dialog.addEventListener('close', () => {

    // Prevent an old timeout from trying to close the dialog again
    clearTimeout(closeTimeout);

    if (player) {
        player.stopVideo();
    }

});